export function in_limits (x, l1, l2) {
    return x >= l1 && x < l2
}

